import React, { useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Transition } from 'react-transition-group';
import { useConnect } from 'redux-bundler-hook';

import {
  StyledCloseNotification,
  StyledNotificationMessage,
  StyledNotifications,
} from './styles';

const modalRoot = document.getElementById('modals');

let notificationTimer;

const Notifications = () => {
  const [readyToExit, setReadyToExit] = useState(false);
  const {
    notificationsMessage: { message, type } = {},
    doDeleteNotificationMessage,
  } = useConnect('doDeleteNotificationMessage', 'selectNotificationsMessage');

  const onExitTimer = useCallback(() => {
    setTimeout(() => {
      doDeleteNotificationMessage();
      setReadyToExit(false);
    }, 500);
  }, [doDeleteNotificationMessage, setReadyToExit]);

  const dismiss = useCallback(() => {
    clearTimeout(onExitTimer);
    clearTimeout(notificationTimer);
    setReadyToExit(true);
  }, [setReadyToExit, onExitTimer]);

  useEffect(() => {
    if (message) {
      clearTimeout(notificationTimer);
      notificationTimer = setTimeout(() => dismiss(), 5000);
    }
    return () => setReadyToExit(false);
  }, [message, type, dismiss]);

  return createPortal(
    <Transition
      in={message && !readyToExit}
      onExited={() => onExitTimer()}
      timeout={250}
    >
      {(state) => {
        return (
          <StyledNotifications onClick={dismiss} transition={state} type={type}>
            <StyledNotificationMessage>{message}</StyledNotificationMessage>
            <StyledCloseNotification>&times;</StyledCloseNotification>
          </StyledNotifications>
        );
      }}
    </Transition>,
    modalRoot,
  );
};

export default Notifications;
